package com.wintermar.inspection.core.ui.util.modifier

import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

fun Modifier.borderExceptTop(
    color: Color,
    width: Dp = 1.dp,
    bottomWidth: Dp = 1.dp,
    bottomLeftRadius: Dp = 0.dp,
    bottomRightRadius: Dp = 0.dp
) = this.drawBehind {
    val strokeWidth = width.toPx()
    val bottomStrokeWidth = bottomWidth.toPx()
    val blRadius = bottomLeftRadius.toPx()
    val brRadius = bottomRightRadius.toPx()

    // inset by half the stroke width so the stroke stays fully inside the bounds
    val half = strokeWidth / 2f
    val bottomHalf = bottomStrokeWidth / 2f

    // left (stops before bottom-left arc; no top inset since top border is absent)
    drawLine(
        color = color,
        start = Offset(half, 0f),
        end = Offset(half, size.height - blRadius - bottomHalf),
        strokeWidth = strokeWidth
    )
    // right (stops before bottom-right arc)
    drawLine(
        color = color,
        start = Offset(size.width - half, 0f),
        end = Offset(size.width - half, size.height - brRadius - bottomHalf),
        strokeWidth = strokeWidth
    )
    // bottom (between the two arcs)
    drawLine(
        color = color,
        start = Offset(blRadius + half, size.height - bottomHalf),
        end = Offset(size.width - brRadius - half, size.height - bottomHalf),
        strokeWidth = bottomStrokeWidth
    )
    // bottom-left arc – rect shifted by (half, -bottomHalf) so its endpoints align with the inset lines
    if (blRadius > 0f) {
        drawArc(
            color = color,
            startAngle = 90f,
            sweepAngle = 90f,
            useCenter = false,
            topLeft = Offset(half, size.height - 2 * blRadius - bottomHalf),
            size = Size(2 * blRadius, 2 * blRadius),
            style = Stroke(width = bottomStrokeWidth)
        )
    }
    // bottom-right arc
    if (brRadius > 0f) {
        drawArc(
            color = color,
            startAngle = 0f,
            sweepAngle = 90f,
            useCenter = false,
            topLeft = Offset(size.width - 2 * brRadius - half, size.height - 2 * brRadius - bottomHalf),
            size = Size(2 * brRadius, 2 * brRadius),
            style = Stroke(width = bottomStrokeWidth)
        )
    }
}
